"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasItemsArray = exports.createDependencyString = exports.processVariant = exports.getPollingInterval = void 0;
/**
 * Pure functions used in useQuery
 */
var api_clients_1 = require("../../api-clients");
var variant_1 = require("../variant");
function isPolling(cachingOptions) {
    return cachingOptions && cachingOptions.type === "polling";
}
function getPollingInterval(options) {
    var cachingOptions = options.caching;
    if (!isPolling(cachingOptions)) {
        return null;
    }
    return cachingOptions.pollingInterval;
}
exports.getPollingInterval = getPollingInterval;
function processVariant(variant) {
    if (variant.result || variant.error) {
        var loading = variant.status !== variant_1.Status.Success && variant.status !== variant_1.Status.Error;
        return { loading: loading, error: variant.error, response: variant.result };
    }
    return { loading: true };
}
exports.processVariant = processVariant;
function createDependencyString(dependencyRef, args) {
    return api_clients_1.getMethodKey(dependencyRef) + ":args(" + JSON.stringify(args) + ")";
}
exports.createDependencyString = createDependencyString;
function hasItemsArray(data) {
    return data && Array.isArray(data.items);
}
exports.hasItemsArray = hasItemsArray;
//# sourceMappingURL=queryFunctions.js.map